// Domain validation - restricts access to approved domains only
const ALLOWED_DOMAINS = [
  'choicemcn.com',
  'www.choicemcn.com',
  'ytgator.com',
  'www.ytgator.com',
  'localhost' // for local development
];

export const validateDomain = () => {
  const hostname = window.location.hostname;
  
  // Check if current domain is allowed
  const isAllowed = ALLOWED_DOMAINS.some(domain => 
    hostname === domain || hostname.includes(domain.replace('www.', ''))
  );
  
  // If accessing from Cloud Run URL, redirect to main domain
  if (hostname.includes('run.app')) {
    window.location.href = 'https://choicemcn.com';
    return false;
  }
  
  // If not an allowed domain, block access
  if (!isAllowed && hostname !== 'localhost' && hostname !== '127.0.0.1') {
    document.body.innerHTML = '<h1>Access Denied</h1><p>This domain is not authorized.</p>';
    return false;
  }
  
  return true;
};